import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie-consent")) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem("cookie-consent", value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 z-50 max-w-sm border border-white/10 bg-deep p-6 shadow-2xl"
        >
          <p className="text-sm leading-relaxed text-ivory/90">
            Folosim cookie-uri de analiză pentru a înțelege cum este folosit
            site-ul. Detalii în{" "}
            <Link to="/politica-cookies" className="text-gold underline underline-offset-4">
              Politica de Cookies
            </Link>
            .
          </p>
          <div className="mt-5 flex gap-3">
            <button
              data-testid="cookie-accept-button"
              onClick={() => choose("accepted")}
              className="bg-gold px-5 py-2.5 text-xs uppercase tracking-[0.2em] text-abyss transition-colors duration-300 hover:bg-gold-hover"
            >
              Accept
            </button>
            <button
              data-testid="cookie-decline-button"
              onClick={() => choose("declined")}
              className="border border-white/20 px-5 py-2.5 text-xs uppercase tracking-[0.2em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              Refuz
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
